import { enrichTemplateKpis } from "./enrichTemplateKpis";
import { compareTemplateItems } from "./compareTemplateItems";

/**
 * Groups the company's selected KPIs by module (one merged Module cell per
 * module, as before) but orders the KPIs *within* each module by category,
 * then subcategory, then title — so KPIs of the same category appear together
 * in the KPI column. Returns an array of `[moduleName, items]` tuples.
 */
export const buildSortedGroups = (input) => {
  const enriched = enrichTemplateKpis(input);

  const groupedByModule = new Map();
  for (const { group, item } of enriched) {
    const moduleName = group.module || "Other";
    if (!groupedByModule.has(moduleName)) groupedByModule.set(moduleName, []);
    groupedByModule.get(moduleName).push({
      ...item,
      category: group.category || "Other",
      subCategory: group.subCategory || "Other",
    });
  }

  return Array.from(groupedByModule.entries())
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([moduleName, items]) => [moduleName, [...items].sort(compareTemplateItems)]);
};
